<template>
  <div class="participants-preview">
    <div class="progress-bar">
      <span class="progress"></span>
      <span class="status">
        <span class="joined">{{preview.total_participants}}</span> of
        <span class="maximum">{{preview.max_participants}}</span>
        participants joined
      </span>
    </div>
    <div class="list users-list" v-if="preview.total_participants > 0">
      <div class="closed" v-if="preview.game.is_closed">
        <table>
          <thead>
            <tr>
              <td>#</td>
              <td>User</td>
              <td>Medal</td>
              <td>Pts</td>
              <td>$</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(participant, i) in preview.allParticipants"
              :key="i"
              :class="{me: (!participant.isBreak && participant.user.key === appState.user.key)}"
              @click="onParticipantClick(participant)"
              >
              <template v-if="participant.isBreak">
                <button @click="loadMoreParticipants()" class="clean small text">...</button>
              </template>
              <template v-else>
                <td>{{participant.reward.rank}}</td>
                <td>{{participant.user.name}}</td>
                <td>{{participant.reward.medal}}</td>
                <td>{{participant.reward.points}}</td>
                <td>${{participant.reward.chips}}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="open" v-else>
        <table>
          <tbody>
            <tr
              v-for="(participant, i) in preview.allParticipants"
              :key="i"
              >
              <template v-if="participant.isBreak">
                <button @click="loadMoreParticipants()" class="clean small text">...</button>
              </template>
              <template v-else>
                <td>{{participant.user.name}}</td>
                <td class="time">{{participant.teamUpdatedAt | simpleDateTimeString}}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <loading-state :state="pageState"></loading-state>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'

export default {
  props: {
    preview: Object
  },
  data () {
    return {
      pageState: DataState.newNotInit()
    }
  },
  methods: {
    loadMoreParticipants () {
      this.pageState.changeToLoading()
      this.preview.loadMoreParticipants().then((resp) => {
        this.pageState.changeToLoaded()
      }).catch((error) => {
        this.pageState.changeToError(error)
      })
    },

    onParticipantClick (participant) {
      if (participant.isBreak) { return }
      this.$emit('participantClick', participant)
    }
  }
}
</script>
